export default {
  methods: {
    getDimentionItemName(id) {
      return this.getDimentionItem(id).name;
    },
    getDimentionName(id) {
      return this.getDimention(id).name;
    },
    getDimentionItem(dimentionId, itemId) {
      return this.getDimentionItems(dimentionId).find(x => x.id === itemId);
    },
    getDimention(id) {
      return this.dimentions.find(x => x.id === id);
    },
    getDimentionItems(id) {
      return this.dimentions.find(x => x.id === id).items;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dimentions.js